export const personnelAccessEnum = {
    Home:"برگه خانه",
    Users:"بخش کاربران",
    Scan:"اسکن در بخش کاربران",
    Entered:"کاربران وارد شده در بخش کاربران",
    AllSubscribes:"عضویت های فعال مجموعه در بخش کاربران",
    UserDetail:"پروفایل کاربران در بخش کاربران",
    SubscribeDetail:"جزئیات عضویت در بخش کاربران",
    SubscribeDetailActions:"افزودن ورود دستی برای کاربر و افزایش تاریخ انقضا عضویت",
    Finance:"بخش مالی",
    FinanceAction:"درخواست های مالی",
    ManagementStatus:"تغییر وضعیت مرکز (فعال یا غیر فعال)",
    ManagementHalls:"مدیریت سالن ها (افزودن سالن جدید یا ویرایش)",
    ManagementTickets:"مدیریت بلیط ها",
    ManagementTicketCourse:"مدیریت بلیط کلاس ها",
    ManagementTicketDiet:"مدیریت تعریف برنامه های غذایی",
    ManagementTicketFood:"مدیریت منو بوفه و رستوران",
    ManagementTicketProduct:"مدیریت محصولات قابل فروش",
    ManagementTicketReserve:"مدیریت رزرو های قابل فروش",
    ManagementTicketService:"مدیریت خدمات قابل فروش",
    ManagementTicketWorkout:"مدیریت تعریف برنامه های تمرینی",
    ManagementTicketSubscribes:"مدیریت عضویت های قابل فروش",
    ManagementImages:"مدیریت تصاویر مجموعه",
    ManagementPersonnel:"مدیریت پرسنل (و دسترسی پرسنل)",
    ManagementAbout:"مدیریت درباره مرکز (قوانین و مقررات و اطلاعات مرکز)",
    ManagementOptions:"مدیریت امکانات مرکز (حذف و اضافه)",
    ManagementSports:"مدیریت ورزش های مرکز",
    ManagementSettingsQr:"مدیریت بخش کنترل qr کد ها در تنظیمات",
    Sells:"فروش ها",
    SellsCourse:"مدیریت کلاس های فروخته شده",
    SellsDiet:"مدیریت برنامه غذایی فروخته شده",
    SellsFood:"مدیریت بوفه و رستوران",
    SellsProduct:"مدیریت فروش محصولات",
    SellsReserve:"مدیریت رزرو های فروخته شده",
    SellsService:"مدیریت سرویس های فروخته شده",
    SellsWorkout:"مدیریت برنامه تمرینی فروخته شده",
    SellsSubscribes:"مدیریت عضویت های فروخته شده",
}
export const personnelAccessEnumT = {
    Home:"Home",
    Users:"Users",
    Scan:"Scan",
    Entered:"Entered",
    AllSubscribes:"AllSubscribes",
    UserDetail:"UserDetail",
    SubscribeDetail:"SubscribeDetail",
    SubscribeDetailActions:"SubscribeDetailActions",
    Finance:"Finance",
    FinanceAction:"FinanceAction",
    ManagementStatus:"ManagementStatus",
    ManagementHalls:"ManagementHalls",
    ManagementTickets:"ManagementTickets",
    ManagementTicketCourse:"ManagementTicketCourse",
    ManagementTicketDiet:"ManagementTicketDiet",
    ManagementTicketFood:"ManagementTicketFood",
    ManagementTicketProduct:"ManagementTicketProduct",
    ManagementTicketReserve:"ManagementTicketReserve",
    ManagementTicketService:"ManagementTicketService",
    ManagementTicketWorkout:"ManagementTicketWorkout",
    ManagementTicketSubscribes:"ManagementTicketSubscribes",
    ManagementImages:"ManagementImages",
    ManagementPersonnel:"ManagementPersonnel",
    ManagementAbout:"ManagementAbout",
    ManagementOptions:"ManagementOptions",
    ManagementSports:"ManagementSports",
    ManagementSettingsQr:"ManagementSettingsQr",
    Sells:"UserSells",
    SellsCourse:"UserSellsCourse",
    SellsDiet:"UserSellsDiet",
    SellsFood:"UserSellsFood",
    SellsProduct:"UserSellsProduct",
    SellsReserve:"UserSellsReserve",
    SellsService:"UserSellsService",
    SellsWorkout:"UserSellsWorkout",
    SellsSubscribes:"UserSellsSubscribes",
}


